/**
 * Preview mode utility — persists ?preview=1 across client navigation via a session cookie.
 *
 * Usage:
 *   activatePreviewMode()  — call when ?preview=1 is detected in the URL
 *   isPreviewModeActive()  — returns true if the cookie is set (client-side)
 *   cookieHasPreview(cookieHeader) — parses a raw Cookie header string (SSR use)
 */

const PREVIEW_COOKIE = 'ras_preview';

/** Activate preview mode: sets a session cookie so it survives SPA navigation. */
export function activatePreviewMode(): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${PREVIEW_COOKIE}=1; path=/; SameSite=Lax`;
}

/** Deactivate preview mode: clears the cookie. */
export function deactivatePreviewMode(): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${PREVIEW_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
}

/** Check if preview mode is active on the client (reads the cookie). */
export function isPreviewModeActive(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  return document.cookie.split(';').some((c) => c.trim().startsWith(`${PREVIEW_COOKIE}=1`));
}

/** Parse a raw Cookie header string for the preview flag (SSR use). */
export function cookieHasPreview(cookieHeader: string | undefined): boolean {
  if (!cookieHeader) {
    return false;
  }
  return cookieHeader.split(';').some((c) => c.trim().startsWith(`${PREVIEW_COOKIE}=1`));
}
